import { when } from '@execonline-inc/maybe-adapter';
import { PaginationMetadata } from '@execonline-inc/resource';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../EmptyFragment';
import GroupsStore from '../../../GroupsStore';
import LoadMore from '../../Pagination/LoadMore';
import { hasResults } from '../../Pagination/pagination';

interface Props {
  store: GroupsStore;
  metadata: PaginationMetadata;
  displayedCount: number;
}

function LoadMoreIf({ store, metadata, displayedCount }: Props) {
  return when(hasResults(metadata), metadata)
    .map((m) => (
      <div className="py-5">
        <LoadMore metadata={m} pageFn={store.loadingMore} displayedCount={displayedCount} />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(LoadMoreIf);
